// App.tsx
import React, {useState, useEffect} from 'react';
import {useSnapshot} from 'valtio';
import {Modal, Select, Space, Tag, UploadFile,message} from 'antd';
import SSEComponent from '@/components/SSEComponent';
import {sseStore} from '@/utils/store/store';
import DocxParser from '@/pages/Index/DocxParser';
import {DeleteOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import AudioParser from '@/pages/Index/AudioParser';
import {UploadChangeParam} from 'antd/es/upload';
import {visitor} from '@/utils/store/visitor';
import {useAuth0} from '@auth0/auth0-react';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';
import Industry from './static/Industry.png';
import template from './static/template.png';
import TemplateCard from '@/pages/Index/compment/TemplateCard';
import logo1 from "@/pages/Index/static/MianType/Notes.png";
import logo2 from "@/pages/Index/static/MianType/Copy-one.png";
import logo3 from "@/pages/Index/static/MianType/Comments.png";
import logo4 from "@/pages/Index/static/MianType/Star.png";
import logo5 from "@/pages/Index/static/MianType/action.png";

import {CiCircleList} from 'react-icons/ci';
import {IoChatbubblesOutline, IoCheckmarkCircleOutline} from 'react-icons/io5';
import {ERROR_MESSAGES, STATUS_MESSAGES} from '@/constants/messages';
import {checkAllParam, handleError} from '@/utils/helpers';
import {FaCircleArrowUp} from "react-icons/fa6";
import {handleWarn} from "@/utils/ui-helpers";
import TemplateCardComment from "@/pages/Index/compment/TemplateCardComment";
import {SlDoc, SlDocs} from "react-icons/sl";
import { TemplateType } from '@/constants/templateTypes';
import submit from "@/pages/Index/static/submit.png";
import OnlineMeetModal from '@/pages/OnlineMeet';
import { AuthStore } from "@/utils/store/auth";
import AddTemplateCard from '@/pages/Index/compment/AddTemplateCard';
import AddTemplateModal from '@/pages/Index/compment/AddTemplateModal';
import TemplateCardUD from '@/pages/Index/compment/TemplateCardUD';
import { CustomTemplateStore } from '@/utils/store/customTemplate';
import CommonLoading from '@/components/CommonLoading';
import { useSnapshot as useCustomTemplateSnapshot } from 'valtio';
import ScenarioTemplateCard from '@/pages/Index/compment/ScenarioTemplateCard';
import { SCENARIO_TEMPLATES_LIST, SCENARIO_TEMPLATES_MAP } from '@/constants/exampleTemplates';

// 文件分隔符常量
const FILE_SEPARATORS = {
  FILE_PREFIX: '\n\n以下是相关文件内容（每一个文件的内容末尾以 -----\n 作为结束标记）：',
  AUDIO_PREFIX: '\n\n以下是相关会议录音转写文字等内容（每一个录音转录的内容末尾以 -----\n 作为结束标记）：',
  CONTENT_END: '-----\n',
};

const { confirm } = Modal;


const Main = () => {
  const { trace, data, loading, error } = useSnapshot(sseStore);
  const [inputParams, setInputParams] = useState<Record<string, any>>({});

  const [TextFileInfo, setTextFileInfo] = useState<UploadChangeParam<UploadFile<any>> | null>(null);
  const [AudioFileInfo, setAudioFileInfo] = useState<UploadChangeParam<UploadFile<any>> | null>(null);
  const [notice, setNotice] = useState<string>("");
  const { count } = useSnapshot(visitor);
  const [selectedKey, setSelectedKey] = useState("");
  const [onlineMeetVisible, setOnlineMeetVisible] = useState(false);
  // const [templateMode, setTemplateMode] = useState<'scenario' | 'classic'>('scenario'); // 模板模式：场景模式或经典模式
  const [templateMode, setTemplateMode] = useState<'scenario' | 'classic' | 'custom'>('classic'); // 模板模式：场景模式或经典模式

  // 只使用 Supabase 认证状态
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  
  // 获取自定义模板状态
  const customTemplateState = useCustomTemplateSnapshot(CustomTemplateStore);
  const { data: customTemplates, isLoading: customTemplatesLoading } = customTemplateState;
    const { data: authData, isLoading: authLoading } = useSnapshot(AuthStore);
  
  // 认证相关状态
  const { user, isAuthenticated, isLoading: isAuthLoading } = supabaseAuth;

  const isNotLogin = !supabaseAuth.isLoading && !supabaseAuth.isAuthenticated && supabaseAuth.user === undefined;
  const [addTemplateModalVisible, setAddTemplateModalVisible] = useState(false);

  // 草稿存储键名常量
  const DRAFT_STORAGE_KEY = 'meetAg_draft';

  /**
   * 从localStorage恢复草稿
   */
  const loadDraft = () => {
    const draft = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (draft) {
      setInputParams(prev => ({ ...prev, Content: draft }));
    }
  };

  // 组件加载时检查是否有草稿
  useEffect(() => {
    const draft = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (draft && !inputParams.Content) {
      // 只在初始加载且没有内容时显示按钮
    }
  }, []);

  // 加载用户自定义模板
  useEffect(() => {
    if (supabaseAuth.isAuthenticated && supabaseAuth.id) {
      CustomTemplateStore.runFetch(supabaseAuth.id);
    }
  }, [supabaseAuth.isAuthenticated, supabaseAuth.id]);

  // 切换模板模式时，清空当前选中的模板
  useEffect(() => {
    setSelectedKey('');
  }, [templateMode]);


  // 处理参数输入变化
  const handleParamChange = (key: string, value: string | Record<string, any>) => {
    setInputParams(prev => ({ ...prev, [key]: value }));
    // 自动保存草稿
    if (key === 'Content' && typeof value === 'string') {
      localStorage.setItem(DRAFT_STORAGE_KEY, value);
    }
  };



  // 提交参数到全局存储（带防抖）
  const updateParams = () => {

    // 正在转录时禁止提交
    if(notice !== "" && notice !== "转录完成"){
      handleWarn("转录进行中，请稍后操作");
      return;
    }

    console.log("update params", inputParams);
    inputParams["time"] = dayjs().format();


    let appendContentPre = '';
    const txtRecordList: Record<string, any> = (inputParams['files'] as Record<string, any>) || {};
    const textNum = txtRecordList ? Object.keys(txtRecordList).length : 0;
    if (textNum > 0) {
      appendContentPre = FILE_SEPARATORS.FILE_PREFIX;
      for (const txtKey of Object.keys(txtRecordList)) {
        appendContentPre += txtRecordList[txtKey];
        appendContentPre += FILE_SEPARATORS.CONTENT_END;
      }
      console.log('追加内容：' + appendContentPre);
    }

    let appendAudioContent = '';
    const audioRecordList: Record<string, any> = (inputParams['parsedContent'] as Record<string, any>) || {};
    const audioNum = audioRecordList ? Object.keys(audioRecordList).length : 0;
    if (audioNum > 0) {
      appendAudioContent = FILE_SEPARATORS.AUDIO_PREFIX;
      for (const audioKey of Object.keys(audioRecordList)) {
        appendAudioContent += audioRecordList[audioKey];
        appendAudioContent += FILE_SEPARATORS.CONTENT_END;
      }
      console.log('追加内容：' + appendAudioContent);
    }
    // let filesContent = inputParams['files']

  
    let User_Define_Template = "";
    let Output_type = selectedKey;
    
    // 判断是否为场景模板
    const isScenarioTemplate = selectedKey.startsWith('scenario_');
    if (isScenarioTemplate) {
      // 场景模板：从 SCENARIO_TEMPLATES_LIST 查找对应的 info
      const scenarioTemplate = SCENARIO_TEMPLATES_LIST.find(t => t.id === selectedKey);
      User_Define_Template = scenarioTemplate?.info || "";
      Output_type = TemplateType.CUSTOM;
    } else {
      // 判断是否为自定义模板
      const isCustomTemplate = selectedKey.startsWith('custom_');
      if (isCustomTemplate) {
        User_Define_Template = customTemplates.find(template => template.id === (selectedKey.replace("custom_","")))?.info || "";
        Output_type = TemplateType.CUSTOM;
      }
    }

    const filesNum = (audioNum+textNum);
    const submitParams = {
      ...inputParams,
      Content: inputParams['Content'] + appendContentPre + appendAudioContent,
      Output_type,
      textNum: textNum.toString(),
      audioNum: audioNum.toString(),
      files: filesNum ? "true" : "",
      User_Define_Template
    };

    if (isNotLogin) {
      if (count > 0) {
        visitor.useFeature();
      } else {
        handleError(null, ERROR_MESSAGES.GUEST_LIMIT_EXCEEDED, 'main', supabaseAuth.id || '', user?.email || '');

        return;
      }
    }

    // console.log("134");
    // console.log(textNum);
    // console.log(audioNum);

    let isLegal = checkAllParam(submitParams,"Industry","Content","Output_type");
    if(!isLegal){
      handleWarn("必填项为空，请补充");
      return;
    }

    sseStore.data = '';
    sseStore.params = submitParams;

    // 提交成功后清空草稿
    localStorage.removeItem(DRAFT_STORAGE_KEY);
  };


  // @ts-ignore
  return (
      <>
        <SSEComponent url="/sse" />

        <div className="shadow-2xs flex-1 border-gray-200 card bg-white overflow-y-auto min-w-[700px] rounded-2xl relative">
          {/* 在线会议按钮 - 右上角徽标形式 */}
          {
            !isAuthLoading && authData?.isSuperAdmin
            &&
            <button
              onClick={() => setOnlineMeetVisible(true)}
              className="absolute top-4 right-4 btn btn-primary btn-xs z-10 shadow-lg"
              title="在线会议卡"
            >
              📝在线会议卡
            </button>
          }
          <div className="card-body p-4 flex flex-col min-h-full">
            <div className="pt-4 pb-2 font-[family-name:--font-pf] text-[24px]  items-center text-center">开始整理记录～</div>


            <div
                className="bg-[#F6F7FC] mb-10  rounded-3xl  h-45 "
                // tabIndex="0"
            >
              {/* 草稿恢复按钮 */}
              {localStorage.getItem(DRAFT_STORAGE_KEY) && !inputParams.Content && (
                <div className="p-3 pb-0">
                  <button
                    onClick={loadDraft}
                    className="btn btn-xs btn-outline btn-secondary"
                  >
                    恢复上次草稿？
                  </button>
                </div>
              )}
              <textarea className="focus:rounded-3xl  textarea textarea-ghost h-33 focus:outline-none  focus:bg-[#F6F7FC] resize-none w-[100%] placeholder:text-[13px]"
                        placeholder="请输入会议笔记、初稿或速记内容，下方可上传录音转录稿等补充材料。"
                        value={inputParams.Content}
                        onChange={(e) => handleParamChange("Content", e.target.value)}
              ></textarea>
              {/*<div className={"p-1 pb-3 pl-3 tooltip "} >*/}
              {/*</div>*/}


              <div className={"flex flex-row pl-3 pr-4"}>
                <div className={"p-1  pl-2 content-center tooltip n tooltip-neutral tooltip-right"} data-tip="📎 支持上传会议转录稿或相关文档，最多 2 个文件。（当前支持格式：docx）">
                  <DocxParser fList={TextFileInfo?.fileList} fileChange={(fileInfo: UploadChangeParam<UploadFile<any>>) => setTextFileInfo(fileInfo)} setData={(docParam: Record<string, any>) => handleParamChange("files", docParam)} />
                </div>
                <div className={"p-1  pl-2 content-center tooltip n tooltip-neutral tooltip-right"} data-tip="🎙️ 支持上传录音文件，最多 1 个。（当前支持格式：wav / m4a / aac / mp3 / ogg）">
                  <AudioParser fList={AudioFileInfo?.fileList} setA2tNotice={setNotice} fileChange = {(fileInfo: UploadChangeParam<UploadFile<any>>) => setAudioFileInfo(fileInfo)}  setData={(docParam: Record<string, any>) => handleParamChange("parsedContent", docParam)} />
                </div>

                <div className={"grow"}>

                </div>
              <div className={" p-1  pl-2 "}>

                
                {/* <button
                    onClick={
                      updateParams
                      // ()=>{
                      //   console.log(204,inputParams['parsedContent'])
                      // }
                    }
                    disabled={loading}
                    className={` hover:cursor-pointer ${inputParams["Content"]? "text-blue-400": "text-[#4B5563]"} `}
                >
                  <img
                    src={submit}
                    className="w-9 h-9
                    "
                    style={{ opacity: 0.8 }}
                  />
                </button> */}
              </div>
              </div>


              <div className={" "} >
                {
                  TextFileInfo && TextFileInfo.fileList && TextFileInfo.fileList.length > 0 &&
                  <div className={"flex flex-row p-1  pl-3"}>
                    {
                      TextFileInfo.fileList.map((file, index) => (
                          <div key={index} className="flex flex-row">
                            <div className={"flex flex-row"}>
                              <Tag color="cyan-inverse">文本</Tag>
                              <div className={"pl-1 pt-0.5"}>{file.name}</div>
                              <div className={"text-sm text-gray-400 pl-0.5 pt-0.5"}>({((file.size || 0) / 1024).toFixed(2)}KB)</div>
                              <button className={"btn btn-xs text-xs text-gray-400 pl-2 ml-1"}
                                      onClick={()=>{
                                        setTextFileInfo({
                                          ...TextFileInfo,
                                          fileList: TextFileInfo.fileList.filter((_, i) => i !== index),
                                        });

                                        const txtFields: Record<string, any> = (inputParams['files'] as Record<string, any>) || {}
                                        if(txtFields ) {
                                          delete txtFields[file.name]
                                        }
                                        handleParamChange("files", txtFields)
                                      }}
                              >
                                <DeleteOutlined />
                              </button>
                            </div>
                          </div>
                      ))
                    }
                  </div>
                }
              </div>
              <div className={""} >
                {
                  AudioFileInfo && AudioFileInfo.fileList && AudioFileInfo.fileList.length > 0 &&
                  <div className={"flex flex-row p-1  pl-3 "}>
                    {
                      AudioFileInfo.fileList.map((file, index) => (
                        <div key={index} className="flex flex-row">
                          <div>
                            <div className={"flex flex-row"}>
                              <Tag color="cyan-inverse">音频</Tag>
                              {
                                notice === "转录完成" && <button
                                  className="btn btn-xs btn-accent text-white"

                                  onClick={
                                    ()=>{
                                      confirm({
                                        title: '预览',
                                        width:'70vw',
                                        content: (inputParams['parsedContent'] as Record<string, any>)?.[file.name] || '',
                                        okText: 'Yes',
                                        okType: 'danger',
                                        okButtonProps: {
                                          disabled: true,
                                        },
                                        cancelText: '关闭',
                                        onOk() {
                                          console.log('OK');
                                        },
                                        onCancel() {
                                          console.log('Cancel');
                                        },
                                      });
                                    }
                                  }
                                >预览</button>
                              }
                              <div className={"pl-2 pt-0.5"}>{file.name}</div>
                              <div className={"text-xs text-gray-400 pl-0.5 pt-0.5"}>({((file.size || 0) / 1024 / 1024).toFixed(2)}MB)</div>
                              <button className={"btn btn-xs text-xs text-gray-400 pl-2 ml-1"}
                              onClick={()=>{
                                setAudioFileInfo({
                                  ...AudioFileInfo,
                                  fileList: AudioFileInfo.fileList.filter((_, i) => i !== index),
                                });
                                const audioFields: Record<string, any> = (inputParams['parsedContent'] as Record<string, any>) || {}
                                if(audioFields ) {
                                  delete audioFields[file.name]
                                }
                                handleParamChange("parsedContent", audioFields)
                                setNotice("")
                              }}
                              >
                                <DeleteOutlined />
                              </button>
                              <div className={"pl-2 pt-0.5"}>
                                {notice}
                              </div>

                            </div>
                            <div className={"flex flex-row"}>
                              {file.percent === 100? <div></div>:
                                <progress className="mt-1 progress progress-accent w-full" value={file.percent} max="100"></progress>
                              }
                              {notice === STATUS_MESSAGES.TRANSCRIBING?
                                <progress className="mt-1 progress w-full"></progress>
                                :<div></div>
                              }


                            </div>

                          </div>


                        </div>
                      ))
                    }
                  </div>
                }

              </div>

            </div>


            <span className={"flex flex-row gap-2 font-[14px]"}>
              <img
                  src={Industry}
                  className="w-5 h-5 h-full"
              />
              <p className="text-sm">行业</p>
            </span>
            <Select
                variant="borderless"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 400,
                  margin: "10px 0px",
                  backgroundColor: "#F6F7FC",
                  borderRadius: "24px",
                  fontSize: "12px"
                }}
                className="rounded-3xl h-5 flex-none"
                placeholder="选择行业领域，确保纪要符合行业特点"
                onChange={(value) => handleParamChange("Industry", value)}
                popupClassName="custom-select-dropdown"
                options={[
                  { value: "企业服务", label: <span>企业服务</span> },
                  { value: "消费文娱电商", label: <span>消费文娱电商</span> },
                  { value: "金融", label: <span>金融</span> },
                  { value: "半导体", label: <span>半导体</span> },
                  { value: "信息科技", label: <span>信息科技</span> },
                  { value: "材料", label: <span>材料</span> },
                  { value: "能源", label: <span>能源</span> },
                  { value: "制造", label: <span>制造</span> }
                ]} />

            <div className="flex flex-row items-center gap-4 mt-4">
              <span className={"flex flex-row gap-2 font-[14px]" }>
                <img
                    src={template}
                    className="w-5 h-5 h-full"
                />
                <p className="text-sm">模板</p>
              </span>
              
              {/* Tabs 切换器 */}
              <ul className="menu menu-horizontal bg-base-200 rounded-box p-1">
                {/* <li>
                  <a 
                    className={templateMode === 'scenario' ? 'menu-active' : ''}
                    onClick={() => setTemplateMode('scenario')}
                  >
                    场景模式
                  </a>
                </li> */}
                <li>
                  <a 
                    className={templateMode === 'classic' ? 'menu-active' : ''}
                    onClick={() => setTemplateMode('classic')}
                  >
                    经典模式
                  </a>
                </li>
                <li>
                  <a 
                    className={templateMode === 'custom' ? 'menu-active' : ''}
                    onClick={() => setTemplateMode('custom')}
                  >
                    自定义模式
                  </a>
                </li>
              </ul>
            </div>

            <div className={"flex flex-wrap gap-4 w-full mt-1 min-w-178"}>
              {/* 场景模式 - 显示场景模板 */}
              {templateMode === 'scenario' && (
                <>
                  {/* 添加自定义模板按钮 - 仅登录用户可见，且非加载状态 */}
                  {/* <AddTemplateCard
                    onClick={() => {
                      if(isAuthenticated && !customTemplatesLoading){
                        setAddTemplateModalVisible(true)
                      } else {
                        message.warning('请先登录')
                      }
                    }}
                  /> */}

                  {/* 自定义模板卡片 */}
                  {/* {customTemplatesLoading ? (
                    <div className="w-56 h-44 flex items-center justify-center">
                      <CommonLoading />
                    </div>
                  ) : (
                    customTemplates.map((template) => (
                      <TemplateCardUD
                        key={template.id || `${template.userId}-${template.title}`}
                        id={template.id}
                        title={template.title}
                        info={template.info}
                        userId={template.userId}
                        value={`custom_${template.id}`}
                        curKey={selectedKey}
                        sk={setSelectedKey}
                      />
                    ))
                  )} */}
                  
                  {/* 场景模板 */}
                  {SCENARIO_TEMPLATES_LIST.map((scenarioTemplate) => (
                    <ScenarioTemplateCard
                      key={scenarioTemplate.id}
                      value={scenarioTemplate.id}
                      iconName={scenarioTemplate.iconName}
                      title={scenarioTemplate.title}
                      desc={scenarioTemplate.shortDesc}
                      curKey={selectedKey}
                      sk={setSelectedKey}
                    />
                  ))}
                </>
              )}
              
              {/* 经典模式 - 显示经典模板 */}
              {templateMode === 'classic' && (
                <>
                  {/* 添加自定义模板按钮 - 仅登录用户可见，且非加载状态 */}
                  {/* <AddTemplateCard
                    onClick={() => {
                      if(isAuthenticated && !customTemplatesLoading){
                        setAddTemplateModalVisible(true)
                      } else {
                        message.warning('请先登录')
                      }
                    }}
                  /> */}

                  {/* 自定义模板卡片 */}
                  {/* {customTemplatesLoading ? (
                    <div className="w-56 h-44 flex items-center justify-center">
                      <CommonLoading />
                    </div>
                  ) : (
                    customTemplates.map((template) => (
                      <TemplateCardUD
                        key={template.id || `${template.userId}-${template.title}`}
                        id={template.id}
                        title={template.title}
                        info={template.info}
                        userId={template.userId}
                        value={`custom_${template.id}`}
                        curKey={selectedKey}
                        sk={setSelectedKey}
                      />
                    ))
                  )} */}
                  
                  {/* 经典模板 */}
                  <TemplateCard value={TemplateType.DEEP} img={logo1} title={"深度纪要"} desc={"逻辑重构 详细记录"} curKey={selectedKey} sk={setSelectedKey} More={null} />
                  {/* <TemplateCard value={TemplateType.DEEP_MULTI} img={logo2} title={"深度纪要（多源版）"} desc={"逻辑重构 详细记录"} curKey={selectedKey} sk={setSelectedKey} More={
                    ()=><TemplateCardComment desc={"适用: 笔记和录音稿等多种资料一起整理"} colorBg={"rgba(112,86,255,0.2)"} colorP={"6A51FF"} className={"h-5"}/>
                  }/> */}
                  <TemplateCard value={TemplateType.DIALOGUE} img={logo3} title={"对话纪要"} desc={"全貌还原 问答记录"} curKey={selectedKey} sk={setSelectedKey} More={null}/>
                  <TemplateCard value={TemplateType.KEY_POINTS} img={logo4} title={"要点概述"} desc={"关键提炼 快速浏览"} curKey={selectedKey} sk={setSelectedKey} More={null}/>
                  <TemplateCard value={TemplateType.TASK_ASSIGNMENT} img={logo5} title={"行动计划"} desc={"任务分配 待办事项"} curKey={selectedKey} sk={setSelectedKey} More={null}/>
                </>
              )}

              {templateMode === 'custom' && (
                <>
                  {/* 添加自定义模板按钮 - 仅登录用户可见，且非加载状态 */}
                  <AddTemplateCard
                    onClick={() => {
                      if(isAuthenticated && !customTemplatesLoading){
                        setAddTemplateModalVisible(true)
                      } else {
                        message.warning('请先登录')
                      }
                    }}
                  />

                  {/* 自定义模板卡片 */}
                  {customTemplatesLoading ? (
                    <div className="w-56 h-44 flex items-center justify-center">
                      <CommonLoading />
                    </div>
                  ) : (
                    customTemplates.map((template) => (
                      <TemplateCardUD
                        key={template.id || `${template.userId}-${template.title}`}
                        id={template.id}
                        title={template.title}
                        info={template.info}
                        userId={template.userId}
                        value={`custom_${template.id}`}
                        curKey={selectedKey}
                        sk={setSelectedKey}
                      />
                    ))
                  )}
                  
                  
                </>
              )}
              
            </div>

            {/* 主提交按钮 - 子容器底部对齐 */}
            <div className="flex-1 flex items-end justify-center mt-8">
              <div className="mb-1 w-48">
                <button
                  onClick={updateParams}
                  disabled={loading}
                  className={`btn border-0  rounded-full  ${loading ? 'btn-disabled' : 
                    inputParams["Content"] ? 'bg-[#99B9FF] hover:bg-blue-700 text-white ' 
                                           : 'bg-gray-100 hover:bg-gray-200 text-gray-700 '}
                    btn-wide text-base font-medium transition-all duration-200 hover:scale-105 shadow-sm`
                  }
                >
                  {loading ? (
                    <>
                      <span className="loading loading-spinner loading-sm"></span>
                      处理中...
                    </>
                  ) : (
                    <>
                      ✨ 开始整理
                    </>
                  )}
                </button>
              </div>
            </div>


            <div className="card-actions justify-end mt-0">

              <Space>
                {/* <Button*/}
                {/*  // type="primary"*/}
                {/*  variant="solid"*/}
                {/*  color="default"*/}
                {/*  onClick={updateParams}*/}
                {/*  loading={loading}*/}
                {/*  disabled={loading}*/}
                {/*>*/}
                {/*  会议整理*/}
                {/*</Button>*/}
                {/*<Button*/}
                {/*  // type="primary"*/}
                {/*  onClick={() => {*/}
                {/*    sseStore.data = "";*/}
                {/*  }}*/}
                {/*>*/}
                {/*  清空*/}
                {/*</Button> */}
              </Space>
            </div>
          </div>

          


        </div>

        {/* 在线会议弹窗 */}
        <OnlineMeetModal 
          visible={onlineMeetVisible}
          onClose={() => setOnlineMeetVisible(false)}
          onMeetingEnd={(notes: string, transcription: string) => {
            // 会议结束后，将笔记和转录内容添加到输入框下方
            const meetingContent = `

=== 会议笔记 ===
${notes}

=== 实时转录 ===
${transcription}`;
            handleParamChange("Content", (inputParams.Content || "") + meetingContent);
            setOnlineMeetVisible(false);
          }}
        />

        {/* 自定义模板添加弹窗 */}
        <AddTemplateModal
          visible={addTemplateModalVisible}
          onClose={() => setAddTemplateModalVisible(false)}
          userId={supabaseAuth.id || ''}
        />

      </>
  );
};

export default Main;